/* Etichetta e colore per ogni ruolo */
export const ROLE_CONFIG = {
  admin:  { label: 'Admin',  className: 'text-violet-400' },
  vip:    { label: 'VIP',    className: 'text-amber-400'  },
  member: { label: 'Member', className: 'text-gray-500'   },
  client: { label: 'Client', className: 'text-blue-400'   },
}

export const getRoleConfig = (role) =>
  ROLE_CONFIG[role] ?? { label: role ?? 'member', className: 'text-gray-500' }
